/**
 * Utility functions for number-related operations.
 */

/**
 * Formats a horometer value detecting its unit (ms, s, or hrs).
 * Always returns a string with thousands separators and no decimals.
 * @param {number | string} value - The horometer value.
 * @returns {string} The formatted string (e.g., "22.252").
 */
export const segundosHoras = (value) => {
    if (!value) return '0'
    let num = Number(value)

    if (num >= 1000000) {
        // Milliseconds (value >= 1 million)
        num = num / 3600000
    }
    // Else: already hours (value < 1 million)

    const horas = Math.floor(num)
    return horas.toLocaleString('es-CL', { maximumFractionDigits: 0 })
}
